module.exports = __webpack_public_path__ + "img/10.aa5c6118.jpg";